export const data = {
  leftMenu:[
    {
      id:7,
      icon:"&#xe604;",
      text:"三维信用诊断系统"
    },
    {
      id:8,
      icon:"&#xe675;",
      text:"企业信管家"
    },
    {
      id:9,
      icon:"&#xe6aa;",
      text:"信用监管套餐"
    },
    {
      id:10,
      icon:"&#xe656;",
      text:"信用档案系统"
    },
    {
      id:11,
      icon:"&#xe627;",
      text:"信用预警机"
    }
  ],
  rightMenu:[
    {
      id:0,
      text:"产品简介"
    },
    {
      id:1,
      text:"核心功能"
    },
    {
      id:2,
      text:"应用场景"
    },
    {
      id:3,
      text:"产品优势"
    },
    {
      id:4,
      text:"客户案例"
    }
  ],
  data:[
    {
      sanweiData: {
        icon:"&#xe604;",
        title: "三维信用诊断系统",
        text: "企业三维信用诊断系统是基于吴氏三维信用理论开发的一款企业信用状况全方位诊" +
          "断与自查的模块化产品，以企业的内外部信用信息，特别是来自外部的公共信用信" +
          "息、司法信息等为基础，利用自主研发定制化三维信用评价模型，自动实现对企业" +
          "的信用监测、画像、等级或评分生成等功能，为政府、协会、金融机构和企业提供" +
          "极具业务针对性与有效性的市场化信用诊断产品。",
      },
      coreData: [
        {
          title: "三维信用诊断",
          text: "依托诚信素质等诚信度信息、政府监管等合规度信息、履约历史等践约度信息，采用智能诊断模型对企业的三维信用状况予以精准度量。"
        },
        {
          title: "多样化诊断结果生成",
          text: "可实现诊断得分、诊断等级、信用 画像、信用诊断报告、信用数据可 视化等多样化诊断结果，满足多样 化企业信用诊断可视化需求。"
        },
        {
          title: "诊断结果轨迹追踪",
          text: "凭借数据的可回溯性与模型结果的稳定性，可轻松实现定制化时间节点的诊断轨迹追踪，预判未来信用诊断结果走势。"
        }
      ],
      sceneData: [
        {
          title: "<span>政府</span><span>部门</span>",
          text: "助力跨部门协同监管与“放管服”改革，提升治理能力与治理现代化水平"
        },
        {
          title: "<span>工商</span><span>企业</span>",
          text: "助力开展合作伙伴信用管理与研判，提升产业链智能化管理水平"
        },
        {
          title: "<span>金融</span><span>机构</span>",
          text: "助力信贷风险评估与监测，拓展业务范围"
        },
        {
          title: "<span>行业</span><span>组织</span>",
          text: "为本行业自律管理提供基于信用的智能化 管理路径，助力行业信用建设"
        }
      ],
      advantage: [
        {
          icon: "&#xe615;",
          title: "信用前沿理论加持",
          text: "基于吴氏三维信用理论开展，诚信、合规、践约信用全方位诊断"
        },
        {
          icon:"",
          title: "规模实践验证",
          text: "模型数十次优化调试，经上百万家企业数据验证，有效率超80%"
        },
        {
          icon: "&#xe670;",
          title: "模块化产品集成",
          text: "产品采取模块化管理，低耦合，并可成套嵌入现有信息系统中"
        },
        {
          icon: "&#xe76b;",
          title: "多渠道数据支撑",
          text: "公共信用信息等合规类数据加持，扎实数据基础为诊断助力"
        },
        {
          icon: "&#xe71c;",
          title: "进阶优化方案对接",
          text: "可高效对接定制化优化方案，不仅诊断，也能“治疗”，一站式解决信用问题"
        },
    
      ],
      case: {
        title: "某能源行业国有企业<br>" +
          "全产业链信用大数据管理与评价设计",
        text: "在公司积极响应国家社会信用体系建设要求、发挥国有企业示范表率作用、助推实现公司战略目标、加强公司信" +
          "用风险管控、建立健全公司信用体系的现实需求下，团队依托公司数据中台，以信用助力公司管理升级为导向，" +
          "结合我国国情与公司实际，构建了全产业链信用分析模型，编制信用大数据清单，搭建信用大数据分析和管控平" +
          "台，并创新公司全产业链“三精管理”，以企业信用建设为该公司创新实现一体化企业信用管理、信用数据多向" +
          "赋能、内外信用双驱动等实施成效，助力企业构建新发展格局。项目荣获2020年度总部管理创新成果二等奖。"
      }
    },
    {
      sanweiData: {
        icon:"&#xe675;",
        title: "企业信管家",
        text: "企业信管家——全流程信用管理系统是一款企业信用管理系统软件。信管家将信" +
          "用管理技术与日常经营业务流程有机结合，以企业的销售业务为核心，在业务的" +
          "事前、事中、事后植入信用管理流程，通过数据管理、部门协作、流程审批、风" +
          "险控制、策略选择、统计分析六大功能，帮助用户在企业内部建立一套完整的信" +
          "用管理机制。"
      },
      coreData: [
        {
          title: "数据管理",
          text: "可提供客户信用信息数据、合同订单数据、信用风险监测数据、付款数据、追缴数据、风险处置数据的管理。"
        },
        {
          title: "部门协作",
          text: "通过系统内统一标准信息与任务在部门间的流转、传递，可实现市场、销售、执行、财务、信用管理等部门之间的高效协作。"
        },
        {
          title: "流程管理",
          text: "通过对企业业务流程的的梳理与部署，可实现对内部管理和运作效率的规范与优化，以及企业日常信用管理的快速电子审批。"
        },
        {
          title:"风险控制",
          text:"通过内置分析模型完成事前对客户的信用评价、信用销售额度度量，事中的信用风险监测预警，事后的债权评估。"
        },
        {
          title:"策略选择",
          text:"帮助企业制定信用销售政策、信用风险预控与处置政策，并根据风险控制结果，完成信用销售策略、预 控对策、风险处置策略选择。"
        },
        {
          title:"统计分析",
          text:"可为企业管理者提供数据可视化的业务多维监测与分析工具，并建立数据监测与风险控制间的映射机制，预警并推送潜在风险信息。"
        }
      ],
      sceneData: [
        {
          title: "<span>核心</span><span>企业</span>",
          text: "供应链核心企业对上下游及供应商信用状况进行维护和管理，合理开展信用销售"
        },
        {
          title: "<span>交易</span><span>市场</span>",
          text: "街区、商品交易市场根据商户信用状况实施信用分类管理，打造诚信经营环境"
        }
      ],
      advantage: [
        {
          icon: "&#xe6ef;",
          title: "与公司业务深度融合",
          text: "可实现企业信用管理与日常经营业务应用之间的紧密结合"
        },
        {
          icon:"&#xe61d;",
          title: "实时信用监测",
          text: "深度结合外部大数据、人工智能等资源，实现实时信用监测"
        },
        {
          icon: "&#xe6be;",
          title: "高效信用风险控制",
          text: "有效控制企业信用风险，显著降低由信用销售带来的经济损失"
        },
        {
          icon: "&#xe670;",
          title: "模块化产品架构",
          text: "采取模块化管理，低耦合，可单独部署，也可成套嵌入现有信息系统中"
        }
      ],
      case: {
        title: "某街区管委会依托“信管家”<br>" +
          "以信用手段实现对街区商户的高效管理",
        text: "信用销售已逐渐成为市场主流销售方式，由于缺乏信用管理知识技术和有效的信用管理工具，客户信用风险暴露" +
          "成为当前企业最主要的风险之一。某街区管委会为提升管理效能，创新采用企业信管家对街区内商户开展信用管" +
          "理。管委会依托信管家系统进行商户入驻筛选，在保证街区商户多样性的同时，根据商户的信用状况择优录取；" +
          "企业入驻后，管委会根据商户的信用等级，设置合理房租账期和房租催收提示，有效降低房租催收人力成本；信" +
          "管家还实现了对街区内的商户的信用分级分类监管，通过合理设置抽检日期、随机分配抽查任务等方式，降低了" +
          "商户应对监管的成本，减少了基层工作人员抽检工作量，从而提升了工作人员和商户的满意度。"
      }
    },
    {
      sanweiData: {
        icon:"&#xe6aa;",
        title: "信用监管套餐",
        text: "信用监管套餐是集信用承诺管理、信用综合评价、信用分级分类监管机" +
          "制构建、信用预警等多元化功能的全流程信用监管应用系统，可与现有" +
          "行政业务系统完美结合，创新建立以诚信、合规、践约三维信用综合评" +
          "价为支撑，事前、事中、事后全流程联动的信用监管模式，套餐式提供" +
          "制度、清单、模型、平台等产品与服务。"
      },
      coreData: [
        {
          title: "信用承诺管理",
          text: "梳理编制承诺清单，并对承诺模板 及内容等实现结构化处理，从而实 现践诺情况线上动态追踪，为事前 环节信用监管提供依据。"
        },
        {
          title: "三维信用综合评价",
          text: "采用智能诊断模型对被监管主体的 三维信用状况特别是合规度信用状 况予以精准度量，并形成等级、画 像等多样化直观结果，便于应用。"
        },
        {
          title: "清单式分类监管机制构建",
          text: "梳理编制承诺清单、数据清单、监 管措施清单、应用事项清单等，可 实现跨部门协同，自动化推送、比 对、拦截、监督的信用监管闭环。"
        },
        {
          title:"智能化监管服务",
          text:"依托大数据监管系统及平台，提供 多维度监管信息定制化筛选与定时 推送、信用大数据预警、信用状态 趋势与行业分析等智能化服务。"
        }
      ],
      sceneData: [
        {
          title: "<span>政府</span><span>部门</span>",
          text: "充分挖掘公共信用信息资源，创新实现高效化、精准化跨部门协同监管"
        },
        {
          title: "<span>产业</span><span>园区</span>",
          text: "依托信用大数据实现对园区企业精准化、良性促进式的信用园区服务与管理"
        },
        {
          title: "<span>街道</span><span>乡镇</span>",
          text: "为基层治理部门创新治理方式提供信用手段，提升治理公信力与效率"
        },
        {
          title: "<span>行业</span><span>组织</span>",
          text: "对会员单位自律管理提供基于信用的智能化管理路径，助力行业信用建设"
        }
      ],
      advantage: [
        {
          icon: "&#xe615;",
          title: "信用前沿理论加持",
          text: "基于吴氏三维信用理论开发，诚信、合规、践约信用全方位分析与监管应用"
        },
        {
          icon:"&#xe61b;",
          title: "闭环式动态联动",
          text: "可实现信用承诺、评价、监管、惩戒、修复等业务闭环的跨部门协同"
        },
        {
          icon: "&#xe6f9;",
          title: "清单目录式管理",
          text: "对庞杂繁复的事项与内容实现清单式梳理与清洗，显著提升工作效率"
        },
        {
          icon: "&#xe670;",
          title: "模块化产品架构",
          text: "采取模块化管理，低耦合，可单独部署，也可成套嵌入现有信息系统中"
        }
      ],
      case: {
        title: "助力某市构建“三维联动”信用监管机制",
        text: "团队基于该市信用建设创新与实效需求，在全国首创跨部门协同联动的“三维联动”信用监管机制。在事前环节，" +
          "全面梳理市级部门行政事项，编制信用承诺事项与内容清单，同时建立与合规度评价映射关系，实现事前信用承" +
          "诺与事中信用分类监管联动，将承诺、践诺和评价结果作为判断失信动机的重要参考，实现事前承诺与事后修复" +
          "管理联动；在事中环节实施差别化协同监管，对企业进行综合信用评价生成“合规度等级”，将等级推送给全市" +
          "各部门，提示监管部门予以注意或采取差别化监管措施，综合、动态反映信用主体在各部门的合规表现；在事后" +
          "环节着重研究制定联合奖惩“两办法+两清单”，将已出台的联合奖惩备忘录分解落实到市级部门，确保奖惩措" +
          "施真正落地。项目荣获省级“创新实践典型案例”称号。"
      }
    },
    {
      sanweiData: {
        icon:"&#xe656;",
        title: "信用档案系统",
        text: "信用档案系统是一套基于信用大数据存储、处理与应用而开发的功能化软件与服" +
          "务系统。通过归集、分类、清洗客户来自内外部的信用大数据资源，基于数据库" +
          "开发与信用应用对接等基础功能，该系统可实现对信用应用资源的全面整合与梳" +
          "理，极大提升数据调用便捷度与资源可用性，为下一步扩大资源渠道、信用拓展" +
          "应用等打下扎实的信息化基础。"
      },
      coreData: [
        {
          title: "数据整理与清洗",
          text: "在深入挖掘与研究实际与潜在需求的基础上，依托科学理论与人工智能等的指导，对海量数据资源进行专项归集、梳理、清洗工作。"
        },
        {
          title: "信用大数据库建构",
          text: "根据数据实际情况与客户现有技术基础，编制数据清单与结构，定制化开展建库建档工作，并可根据潜在应用方向及时调整。"
        },
        {
          title: "档案管理与应用",
          text: "建立信用档案调用与映射机制，在考虑智能化、安全性、易用性的前提下，实现信用档案及其相关数据的自动化管理与应用"
        }
      ],
      sceneData: [
        {
          title: "<span>政府</span><span>部门</span>",
          text: "充分发挥多部门信用大数据综合实效，助力智能化监管与政务服务提升"
        },
        {
          title: "<span>平台</span><span>机构</span>",
          text: "助力信用大数据归集与应用，真正实现平台化数据整合优势"
        },
        {
          title: "<span>核心</span><span>企业</span>",
          text: "供应链核心企业对上下游及自身信用数据资源进行梳理、维护和管理"
        },
        {
          title: "<span>产业</span><span>园区</span>",
          text: "发挥园区特定产业信用数据资源优势，助力园区管理与创新示范输出"
        }
      ],
      advantage: [
        {
          icon: "&#xe616;",
          title: "丰富规范与标准经验",
          text: "调研、参与多项建档建库业务，数据规范与标准经验丰富"
        },
        {
          icon:"&#xe614;",
          title: "深度融合信用要素",
          text: "全面服务于配套信用应用，全流程信用理论支撑与要素设计"
        },
        {
          icon: "&#xe635;",
          title: "便捷对接配套方案",
          text: "预置调用与对接模块，一站式高效满足配套信用应用方案实现"
        }
      ],
      case: {
        title: "信用档案系统<br>" +
          "助力国家某行业主管部门信用监管",
        text: "行业信用信息平台逐渐成为行业信用建设的关键抓手。如何充分利用好这一抓手实现现代化行业信用监管与服务，" +
          "是各行各业值得思考的领域。国家某行业主管部门与团队深入探讨合作，采用信用档案系统，依托行业信用信息" +
          "平台，实现了信用信息录入、查询、异议处理、信用统计分析等功能，将市场主体散落在行业各监管机构、行业" +
          "协会、企业等各处的信息进行汇集、加工和整理，实现对信用信息的一体化管理，改变行业信息收集渠道少、耗" +
          "费时间长的现状。由于系统的业务对接便捷高效，平台现已逐步发展为一个中心：行业信用信息数据中心；两个" +
          "体系：信用信息归集和共享体系、信用信息应用体系；两个配套：配套的网站、APP。"
      }
    },
    {
      sanweiData: {
        icon:"&#xe627;",
        title: "信用预警机",
        text: "信用预警机是一款基于多维度信用预警模型而开发的系统软件，将企业外部数据" +
          "和内部业务与管理数据进行有机整合，通过对企业关注对象设置监控，实时了解" +
          "其动态，并可根据定制化条件触发预警。信用预警机助力使用者以信用为基础实" +
          "现资源最优配置，是实现用户管理与上下游管理的好帮手，是实现跨部门协同管" +
          "理、联合奖惩的助推器。"
      },
      coreData: [
        {
          title: "外部资源对接",
          text: "通过接口、关联、抓取等方式实现与外部资源、算力的实时对接，可依托任意内外部信息平台，实现数据、分析结果等的实时获取。"
        },
        {
          title: "信用档案建构",
          text: "在充分理解业务实质基础上，以信用为标准进行数据准备、清洗、资源梳理，提升数据资源可用性，建构科学易用的信用预警数据库。"
        },
        {
          title: "多维预警管理",
          text: "根据实际使用需求，可定制预警触发条件及多样化预警可视化结果，并通过业务系统、邮件、微信等多种方式实时推送给业务人员"
        }
      ],
      sceneData: [
        {
          title: "<span>政府</span><span>部门</span>",
          text: "充分利用公共信用信息，优化监管力量分配，实现联合奖惩应用和重点企业预警 "
        },
        {
          title: "<span>企业</span><span>机构</span>",
          text: "盘活企业数据资源，对企业交易对手进行实时监控，防范信用风险"
        },
        {
          title: "<span>行业</span><span>组织</span>",
          text: "对本行业企业实施动态监督管理，及早发现业内问题，提升行业诚信经营环境"
        }
      ],
      advantage: [
        {
          icon: "&#xe60d;",
          title: "科学理论建模支撑",
          text: "以科学、基于前沿信用理论的信用评价与预警模型为支撑"
        },
        {
          icon:"&#xe64f;",
          title: "风险识别有效前移",
          text: "提前预知风险，尽早做出判断，定制化预警提示与推送"
        },
        {
          icon: "&#xe721;",
          title: "盘活数据资产价值",
          text: "专注数据资产价值实现，充分发挥档案式信用数据整理与调用实效"
        },
        {
          icon: "&#xe670;",
          title: "模块化产品架构",
          text: "采取模块化管理，低耦合，可单独部署，也可成套嵌入现有信息系统中"
        }
      ],
      case: {
        title: "信用预警机助力跨部门协同监管与精准监管",
        text: "某市公共信用信息平台归集了数十个政府部门和市场机构的信用信息，但由于信息数据标准存在差异、各部门主" +
          "监管侧重点不同等原因，部门间实现互联互通难度较大，联合监管难，部门工作压力巨大，跨部门联合奖惩无从" +
          "实现。在此背景下，某职能部门与团队密切合作，采取搭建平台并采购使用信用预警机的方式，将各部门掌握的" +
          "数据进行清洗、归档与整理，并通过信用预警信息共享的方式，为相关的部门精准定位重点监管群体，成功实现" +
          "风险识别环节前移，大幅降低了由市场主体数量激增带来的监管难度；同时实现各监管部门之间评价结果互认，" +
          "各部门不再仅仅从业务监管视角出发，而从整体监管的视角对下辖企业进行客观评价与预警，使得监管力量的运" +
          "用能更为高效、有力。"
      }
    }
  ]
}
